"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedUnits = exports.Second = exports.Minute = exports.Hour = exports.Day = exports.Month = exports.Year = exports.Weekday = exports.TimeStyle = exports.DateStyle = exports.NumericTwoDigit = exports.TimeZoneName = exports.DateTimeStyle = void 0;
exports.DateTimeStyle = {
    FULL: "full",
    LONG: "long",
    MEDIUM: "medium",
    SHORT: "short",
};
exports.TimeZoneName = {
    LONG: "long",
    SHORT: "short",
};
exports.NumericTwoDigit = {
    NUMERIC: "numeric",
    TWO_DIGIT: "2-digit",
};
exports.DateStyle = exports.DateTimeStyle;
exports.TimeStyle = exports.DateTimeStyle;
exports.Weekday = {
    LONG: "long",
    SHORT: "short",
    NARROW: "narrow",
};
exports.Year = exports.NumericTwoDigit;
exports.Month = {
    NUMERIC: "numeric",
    TWO_DIGIT: "2-digit",
    LONG: "long",
    SHORT: "short",
    NARROW: "narrow",
};
exports.Day = exports.NumericTwoDigit;
exports.Hour = exports.NumericTwoDigit;
exports.Minute = exports.NumericTwoDigit;
exports.Second = exports.NumericTwoDigit;
exports.supportedUnits = [
    "second",
    "minute",
    "hour",
    "day",
    "month",
    "year",
    "weeks",
    "quarter",
];
//# sourceMappingURL=DateTime.types.js.map